var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import deprecated from 'react-prop-types/lib/deprecated';
import isRequiredForA11y from 'react-prop-types/lib/isRequiredForA11y';
import getDeprecatedIcon from '../FontIcons/getDeprecatedIcon';
import FontIcon from '../FontIcons/FontIcon';
import SelectionControl from './SelectionControl';

/**
 * The `Radio` component is used for the selection of a single option from a set. Unfortunately
 * the `Radio` component must always be controlled because of the `FontIcon` toggles and how
 * the `radio` input type works. It is recommended to use the `SelectionControlGroup` component
 * to manage the `radio`.
 */

var Radio = function (_PureComponent) {
  _inherits(Radio, _PureComponent);
  function Radio() {
    _classCallCheck(this, Radio);
    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }
  Radio.prototype.render = function render() {
    var _props = this.props,
      checkedIcon = _props.checkedIcon,
      uncheckedIcon = _props.uncheckedIcon,
      checkedIconChildren = _props.checkedIconChildren,
      checkedIconClassName = _props.checkedIconClassName,
      uncheckedIconChildren = _props.uncheckedIconChildren,
      uncheckedIconClassName = _props.uncheckedIconClassName,
      props = _objectWithoutProperties(_props, ['checkedIcon', 'uncheckedIcon', 'checkedIconChildren', 'checkedIconClassName', 'uncheckedIconChildren', 'uncheckedIconClassName']);
    var checked = getDeprecatedIcon(checkedIconClassName, checkedIconChildren, checkedIcon);
    var unchecked = getDeprecatedIcon(uncheckedIconClassName, uncheckedIconChildren, uncheckedIcon);
    return React.createElement(SelectionControl, _extends({
      type: 'radio',
      checkedCheckboxIcon: checked,
      uncheckedCheckboxIcon: unchecked,
      __superSecreteProp: true
    }, props));
  };
  return Radio;
}(PureComponent);
Radio.propTypes = {
  /**
   * An id to use with the radio. This is used for accessibility and so that the label
   * triggers the radio toggle.
   */
  id: isRequiredForA11y(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  /**
   * An optional style to apply to the radio's container.
   */
  style: PropTypes.object,
  /**
   * An optional className to apply to the radio's container.
   */
  className: PropTypes.string,
  /**
   * A label to display with the radio. This is required for accessibility and triggering
   * the toggle.
   */
  label: PropTypes.node.isRequired,
  /**
   * Boolean if the label should appear before the radio icon.
   */
  labelBefore: PropTypes.bool,
  /**
   * A name to use for the `Radio`. This is required for accessibility.
   */
  name: isRequiredForA11y(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  /**
   * Boolean if the `Radio` is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * A function to call when the `Radio` triggers the `change` event. The `onChange` callback
   * will include the current value of the checked `radio` and the change event.
   *
   * ```js
   * onChange(changeEvent.target.value, changeEvent);
   * ```
   */
  onChange: PropTypes.func,
  /**
   * The value for the `Radio` component.
   */
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]).isRequired,
  /**
   * A boolean if the `Radio` is currently checked.
   */
  checked: PropTypes.bool.isRequired,
  /**
   * Boolean if the `Radio` should be displayed inline.
   */
  inline: PropTypes.bool,
  /**
   * Whether the `change` event should be triggered for `Radio` on pressing of `Enter` key.
   */
  changeOnEnter: PropTypes.bool,
  /**
   * The icon to display when the radio is checked/selected.
   */
  checkedIcon: PropTypes.node.isRequired,
  /**
   * The icon to display when the radio is not checked/selected.
   */
  uncheckedIcon: PropTypes.node.isRequired,
  checkedIconChildren: deprecated(PropTypes.node, 'Use `checkedIcon` instead'),
  checkedIconClassName: deprecated(PropTypes.string, 'Use `checkedIcon` instead'),
  uncheckedIconChildren: deprecated(PropTypes.node, 'Use `uncheckedIcon` instead'),
  uncheckedIconClassName: deprecated(PropTypes.string, 'Use `uncheckedIcon` instead')
};
Radio.defaultProps = {
  checkedIcon: React.createElement(FontIcon, null, 'radio_button_checked'),
  uncheckedIcon: React.createElement(FontIcon, null, 'radio_button_unchecked')
};
export default Radio;